import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {defaultProductParams, ProductSortOrder, ProductsParamsType} from "@/lib/products";
import {ProductGroupLevel, productGroupNames} from "@/types/product-group";


export const productsSlice = createSlice({
    name: 'products',
    initialState: {
        ...defaultProductParams,
        productGroups: [] as number[],
    },
    reducers: {
        resetFilters: (s) => {
            s.OnlyOffers = false;
            s.OnlyNewests = false;
        },

        setProductsParams: (state, action: PayloadAction<ProductsParamsType>) => {
            const newParams = action.payload;

            let shouldResetPage = false;

            for (const key in newParams) {
                if (
                    key !== "Page" &&
                    key in state &&
                    JSON.stringify((state as any)[key]) !== JSON.stringify((newParams as any)[key])
                ) {
                    shouldResetPage = true;
                    break;
                }
            }

            const finalParams = {
                ...state,
                ...newParams,
                Page: shouldResetPage ? 1 : (newParams.Page || state.Page),
            };

            Object.assign(state, finalParams);
        },
        setProductsParamsRaw(state, action) {
            const payload = action.payload;
            return {
                ...defaultProductParams,
                productGroups: [],
                ...payload
            };
        },
        addProductGroup: (state, action: PayloadAction<{ id: number; pLevel: ProductGroupLevel }>) => {
            const { id, pLevel } = action.payload;
            if (isNaN(id)) return;

            const productGroupName = productGroupNames[pLevel];
            const currentList = state[productGroupName] as number[];

            const alreadyExists = currentList.includes(id);

            if (alreadyExists) {
                state[productGroupName] = currentList.filter(item => item !== id);
            } else {
                state[productGroupName] = [...currentList, id];
            }

            state.Page = 1;

        },
        changeSortOrder: (state, action: PayloadAction<ProductSortOrder>) => {
            state.SortOrder = action.payload
        },
        setOnlyWithPicture: (state, action: PayloadAction<boolean>) => {
            state.OnlyWithPicture = action.payload;
        },
        setSearchText: (state, action) => {
            state.SearchText = action.payload;
        },

    }
})

export const {
    resetFilters,
    setProductsParams,
    setProductsParamsRaw,
    addProductGroup,
    changeSortOrder,
    setOnlyWithPicture,
    setSearchText
} = productsSlice.actions
const productsReducer = productsSlice.reducer
export default productsReducer
